import PropTypes from 'prop-types'
import { Chip, Tooltip } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import { ReactComponent as StepCancelledStatusChip } from '../../../assets/icons/step-cancelled-status-chip.svg'
import { ReactComponent as WarningFill } from '../../../assets/icons/warning-fill.svg'
import { ReactComponent as Edit } from '../../../assets/icons/edit.svg'
import { ReactComponent as Resolve } from '../../../assets/icons/edit.svg'
import { ReactComponent as ReturnArrow } from '../../../assets/icons/return-arrow.svg'
import {
  INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION,
  SHIPPING_STATUS_CODES,
} from '../../../common/constants'
import { useHistory } from 'react-router-dom'

const StatusCodeChip = ({
  state,
  size = 'small',
  hasIncident,
  isCancelled,
  isUnscheduledPickup,
  isRequestedReturn,
  id,
  ...muiProps
}) => {
  const formatMessage = useTranslations()
  const t = useTranslations()
  const history = useHistory()

  const isSolvable =
    INCIDENTS_CODES_ALLOWED_FOR_RESOLUTION.includes(state?.incidentCode) &&
    (state?.lastStatusCode === SHIPPING_STATUS_CODES.incidentDelivering ||
      state?.lastStatusCode === SHIPPING_STATUS_CODES.delivering)

  const formatName = name => {
    if (isUnscheduledPickup) {
      return formatMessage('tracking-line:pickup-unscheduled')
    }
    let nameArray = name.split(' ')
    if (hasIncident && name !== '-') {
      switch (nameArray[nameArray.length - 1].toLowerCase()) {
        case 'recogido':
          return `Incidencia en la recogida`
        case 'entregado':
          return `Incidencia en la entrega`
        case 'devuelto':
          return `Incidencia en la devolución`
        default:
          return `Incidencia en el ${nameArray[
            nameArray.length - 1
          ].toLowerCase()}`
      }
    } else if (!state?.lastStatusDescription) return state
    return state?.lastStatusDescription
  }

  return (
    <Tooltip
      disableHoverListener={
        isCancelled ||
        !(
          hasIncident ||
          (hasIncident && state?.severity !== 'orange' && isSolvable) ||
          isUnscheduledPickup
        )
      }
      title={
        !isCancelled &&
        hasIncident &&
        state?.severity !== 'orange' &&
        isSolvable
          ? t('tooltip:resoluble')
          : isUnscheduledPickup
          ? t('tooltip:schedule')
          : hasIncident && state?.severity !== 'orange'
          ? t('tooltip:not-resoluble')
          : t('tooltip:solved')
      }
      arrow
      placement="top"
    >
      <Chip
        icon={
          isCancelled ? (
            <StepCancelledStatusChip />
          ) : hasIncident && state?.severity !== 'orange' && isSolvable ? (
            <Resolve />
          ) : isUnscheduledPickup ? (
            <Edit />
          ) : hasIncident ? (
            <WarningFill />
          ) : isRequestedReturn &&
            SHIPPING_STATUS_CODES.delivered === state?.lastStatusCode ? (
            <Tooltip title={t('tooltip:return-shipment')} arrow placement="top">
              <ReturnArrow
                onClick={() =>
                  history.push(`/shippings-tracking/${isRequestedReturn}`)
                }
              ></ReturnArrow>
            </Tooltip>
          ) : null
        }
        size={size}
        classes={{
          root: isCancelled
            ? 'red'
            : isUnscheduledPickup
            ? 'yellow'
            : state?.severity,
        }}
        label={
          isCancelled ? (
            <div
              onClick={() => {
                if (id) history.push(`/shippings-tracking/${id}`)
              }}
            >
              {formatMessage('tracking:cancelled')}
            </div>
          ) : (
            <div
              onClick={() => {
                if (id) history.push(`/shippings-tracking/${id}`)
              }}
            >
              {formatName(state?.lastStatusDescription ?? '')}
            </div>
          )
        }
        {...muiProps}
      />
    </Tooltip>
  )
}

StatusCodeChip.propTypes = {
  id: PropTypes.string,
  state: PropTypes.shape({
    shippingCode: PropTypes.string,
    lastStatusCode: PropTypes.string,
    lastStatusDescription: PropTypes.string,
    incidentCode: PropTypes.string,
    severity: PropTypes.string.isRequired,
  }),
  size: PropTypes.oneOf(['small', 'medium']),
  hasIncident: PropTypes.bool,
  isCancelled: PropTypes.bool,
  isUnscheduledPickup: PropTypes.bool,
  isRequestedReturn: PropTypes.bool,
}

export default StatusCodeChip
